<template>
  <div v-show="isShow">
    <div class="content-top">
      <i-row style="width:100%">
        <i-col span="8" offset="7" class="content-search">
          <i-input
            placeholder="模糊搜索"
            style="width: 250px"
            v-model="search_key"
            clearable
            @on-clear="search_key_clear"
            @keyup.enter.native="searchBtn"
          />
          <i-button type="info" icon="md-search" class="search" @click="searchBtn">搜索</i-button>
        </i-col>
        <i-col span="3" offset="5" v-if="isShowAddButton">
          <i-button type="success" class="article-button" @click="showAddContentModal">
            <i class="iconfont icon-tianjia" style="marginRight:5px"></i>
            新增
          </i-button>
        </i-col>
      </i-row>
    </div>
    <div class="content-main">
      <i-table
        class="content-table"
        :columns="finalColumns"
        :data="contentData"
        @on-sort-change="sortChange"
        @on-filter-change="filterChange"
        stripe
        border
      >
        <template slot="top" slot-scope="{ row }">
          <i-switch v-model="row.top" @on-change="changeTop(row)" />
          {{ row.top ? "是" : "否" }}
        </template>
        <template slot-scope="{ row }" slot="content">
          <p class="content">
            {{ row.content }}
          </p>
        </template>
        <!-- 操作 -->
        <template slot="operate" slot-scope="{ row }">
          <i-button type="warning" class="article-button" @click="showEditContentModal(row)">
            <i class="iconfont icon-weibiaoti2010104" style="marginRight:5px;"></i>
            编辑
          </i-button>
          <i-button type="error" class="article-button" @click="deleteTemplate(row)" v-if="isShowAddButton">
            <i class="iconfont icon-lajitong operate-icon"></i>
            删除
          </i-button>
        </template>
      </i-table>
      <!-- 分页器 -->
      <i-page
        :total="total"
        :page-size-opts="pageSizeOpts"
        size="small"
        show-elevator
        show-sizer
        show-total
        placement="top"
        :current="current"
        :page-size="pageSize"
        @on-change="pageChange"
        @on-page-size-change="pageSizeChange"
      />
    </div>
    <!-- loading-->
    <div v-if="showLoading" class="demo-spin-col" span="8">
      <i-spin fix>
        <i-icon type="ios-loading" size="18" class="demo-spin-icon-load"></i-icon>
        <div>Loading</div>
      </i-spin>
    </div>
    <add-content-modal
      :is-show="isShowAddContent"
      @cancel="cancel"
      @success="success"
      :channel="channel"
      :closable="isClosableAddContent"
    />
    <edit-content-modal
      :is-show="isShowEditContent"
      @cancel="cancel"
      @success="success"
      :channel="channel"
      :edit-data="editData"
      :closable="isClosableEditContent"
    />
  </div>
</template>

<script>
import AddContentModal from "./Content/AddContentModal"
import EditContentModal from "./Content/EditContentModal"
import { baseConfigMixin } from "./mixin"
export default {
  name: "Channel",
  components: { EditContentModal, AddContentModal },
  props: {
    channel: {
      type: String,
    },
    content: {
      type: String,
      default: "",
    },
  },
  mixins: [baseConfigMixin],
  data() {
    return {
      total: 10,
      current: 1,
      pageSize: null,
      pageSizeOpts: [10, 20, 30, 40, 50, 100],
      contentData: [],
      columns: [
        {
          type: "selection",
          width: 30,
          align: "center",
          resizable: true,
        },
        {
          title: "标题",
          key: "title",
          minWidth: 80,
          align: "center",
          resizable: true,
        },
        {
          title: "发布时间",
          key: "published_time",
          minWidth: 80,
          align: "center",
          sortable: "custom",
          resizable: true,
        },
        {
          title: "内容",
          key: "content",
          slot: "content",
          minWidth: 100,
          align: "center",
          resizable: true,
        },
        {
          title: "是否置顶",
          key: "top",
          slot: "top",
          width: 100,
          align: "center",
          resizable: true,
        },
        {
          title: "操作",
          key: "operate",
          slot: "operate",
          width: 200,
          align: "center",
        },
      ],
      finalColumns: [],
      search_key: "",
      showLoading: true,
      channels: [],
      isShowAddContent: false,
      isClosableAddContent: true,
      isShowEditContent: false,
      isClosableEditContent: true,
      editData: {},
      order_by: {},
      init: true,
      isShow: true,
      isShowAddButton: true,
      attrFilter: {},
      attrSortable: {},
      isArticle: false,
      allowCreate: false,
    }
  },
  watch: {
    async channel() {
      this.isShow = true
      await this.openInit()
    },
  },
  methods: {
    getChannels() {
      this.channels = []
      this.channels.push(this.channel)
    },
    // page改变事件
    pageChange(index) {
      this.current = index
      this.getContentList()
    },
    pageSizeChange(size) {
      this.pageSize = size
      localStorage.setItem("pageSize", size)
      this.$store.commit("changePageSize", size)
      this.getContentList()
    },
    // 搜索
    searchBtn() {
      this.current = 1
      this.getContentList()
    },
    search_key_clear() {
      this.current = 1
      this.getContentList()
    },
    //获取频道信息
    async getChannelDetail() {
      let self = this
      self.showLoading = true
      try {
        const res = await self.axios({
          method: "get",
          url: self.cmsUrl + "api/content/channel/get",
          params: {
            name: this.channel,
          },
        })
        if (!res) {
          return
        }
        if (res.data.code === 0) {
          this.isArticle = res.data.data.isArticle
          this.allowCreate = res.data.data.allowCreate
        } else {
          self.isShow = false
          self.showLoading = false
          self.$Message.error("操作失败，错误原因：" + res.data.error_message)
          console.log(res)
        }
      } catch (err) {
        self.showLoading = false
        self.$Message.error("操作失败，错误原因：" + err)
        console.log(err)
      }
    },
    //获取列表信息
    async getContentList() {
      let self = this
      self.showLoading = true
      self.isClosableAddContent = true
      self.isClosableEditContent = true
      let xData = {}
      xData = {
        p: this.current,
        p_size: this.pageSize,
        channels: this.channels,
      }
      if (this.search_key) {
        xData["search_key"] = this.search_key
      }
      if (this.order_by && JSON.stringify(this.order_by) !== "{}") {
        xData["order_by"] = this.order_by
      }
      if (this.attrFilter && JSON.stringify(this.attrFilter) !== "{}") {
        xData["attr_filter"] = this.attrFilter
      }
      if (this.attrSortable && JSON.stringify(this.attrSortable) !== "{}") {
        xData["attr_sortable"] = this.attrSortable
      }
      try {
        const res = await self.axios({
          method: "get",
          url: self.cmsUrl + "api/content/content/list",
          params: {
            ...xData,
          },
        })
        if (!res) {
          return
        }
        if (res.data.code === 0) {
          if (this.init) {
            this.init = false
            let add = []
            if (res.data.data.data.length > 0) {
              let channelAttributes = {}
              // 拿取channel attribute的配置
              for (let item in res.data.data.data[0].channel.attributes) {
                channelAttributes[res.data.data.data[0].channel.attributes[item].type] =
                  res.data.data.data[0].channel.attributes[item]
              }
              for (let item in res.data.data.data[0].attributes) {
                let isFile = false
                let title = null
                if(channelAttributes[item]) {
                  title = channelAttributes[item].name
                }
                if (item.indexOf("cms__file") !== -1) {
                  isFile = true
                }
                if(title) {
                  let config = {
                    title: title,
                    key: item,
                    minWidth: 120,
                    align: "center",
                    render: (h, params) => {
                      let content = '<p style="display: -webkit-box;-webkit-line-clamp: 3;-webkit-box-orient: vertical;overflow: hidden;">' + params.row.attributes[item] + '</p>'
                      if (isFile) {
                        if (params.row.attributes[item]) {
                          content =
                            "<a href='" +
                            params.row.attributes[item] +
                            "' target='_blank'>" +
                            content +
                            "</a>"
                        }
                      }
                      return h("span", {
                        domProps: {
                          innerHTML: content,
                        },
                      })
                    },
                  }
                  if (channelAttributes[item].sortable) {
                    config["sortable"] = "custom"
                  }
                  if (item.indexOf("cms__enum") !== -1) {
                    let filters = []
                    for (let i = 0; i < channelAttributes[item].value.length; i++) {
                      filters.push({
                        label: channelAttributes[item].value[i],
                        value: channelAttributes[item].value[i],
                      })
                    }
                    config["filters"] = filters
                    config["filterMethod"] = function () {
                      return true
                    }
                  }
                  add.push(config)
                }
              }
            }
            let _columns = []
            _columns = JSON.parse(JSON.stringify(this.columns))
            _columns.splice(4, 0, ...add)
            this.finalColumns = []
            this.finalColumns.push(..._columns)
          }
          self.contentData = []
          self.contentData.push(...res.data.data.data)
          if (self.isArticle) {
            if (self.contentData.length === 0) {
              this.isClosableAddContent = false
              this.showAddContentModal()
            } else if (self.contentData.length === 1) {
              this.isClosableEditContent = false
              this.showEditContentModal(self.contentData[0])
            }
          }
          self.total = res.data.data.total
          self.showLoading = false
        } else {
          self.showLoading = false
          self.$Message.error("操作失败，错误原因：" + res.data.error_message)
          console.log(res)
        }
      } catch (err) {
        self.showLoading = false
        self.$Message.error("操作失败，错误原因：" + err)
        console.log(err)
      }
    },
    cancel() {
      this.editData = {}
      this.isShowAddContent = false
      this.isShowEditContent = false
    },
    success() {
      this.init = true
      this.getChannels()
      this.getContentList()
      this.editData = {}
      this.isShowAddContent = false
      this.isShowEditContent = false
    },
    showAddContentModal() {
      this.isShowAddContent = true
    },
    showEditContentModal(value) {
      this.editData = value
      this.isShowEditContent = true
    },
    deleteTemplate(row) {
      const self = this
      this.$Modal.confirm({
        title: "确认",
        content: "<p>要删除" + row.title + "吗？</p>",
        onOk: async () => {
          self.showLoading = true
          try {
            const res = await self.axios({
              method: "delete",
              url: self.cmsUrl + "api/content/content/delete",
              params: {
                cids: [row.id],
              },
            })
            if (!res) {
              return
            }
            if (res.data.code === 0) {
              self.showLoading = false
              self.$Message.success("删除成功！")
              self.success()
            } else {
              self.showLoading = false
              self.$Message.error("操作失败，错误原因：" + res.data.error_message)
              console.log(res)
            }
          } catch (err) {
            self.showLoading = false
            self.$Message.error("操作失败，错误原因：" + err)
            console.log(err)
          }
        },
      })
    },
    async changeTop(value) {
      const self = this
      self.showLoading = true
      let xData = {
        cid: value.id,
        top: value.top,
      }
      try {
        const res = await self.axios({
          method: "post",
          url: self.cmsUrl + "api/content/content/edit",
          data: xData,
        })
        if (!res) {
          return
        }
        if (res.data.code === 0) {
          self.showLoading = false
          self.$Message.success("修改成功！")
          await this.getContentList()
        } else {
          self.showLoading = false
          self.$Message.error("操作失败，错误原因：" + res.data.error_message)
          console.log(res)
        }
      } catch (err) {
        self.showLoading = false
        self.$Message.error("操作失败，错误原因：" + err)
        console.log(err)
      }
    },
    sortChange(column) {
      this.order_by = {}
      this.attrSortable = {}
      if (column.order === "desc") {
        if (column.key.indexOf("cms__") !== -1) {
          this.attrSortable[`asc`] = [0]
          this.attrSortable[`field`] = [column.key]
        } else {
          this.order_by[`asc`] = [0]
          this.order_by[`field`] = [column.key]
        }
      } else if (column.order === "normal") {
        this.attrSortable = {}
        this.order_by = {}
      } else {
        if (column.key.indexOf("cms__") !== -1) {
          this.attrSortable[`asc`] = [1]
          this.attrSortable[`field`] = [column.key]
        } else {
          this.order_by[`asc`] = [1]
          this.order_by[`field`] = [column.key]
        }
      }
      this.getContentList()
    },
    filterChange(col) {
      this.attrFilter = {}
      if (col._filterChecked.length > 0) {
        this.attrFilter[col.key] = col._filterChecked
      }
      this.getContentList()
    },
    async openInit() {
      await this.getChannelDetail()
      if (this.isShow) {
        if (!this.isAdmin && !this.allowCreate) {
          this.isShowAddButton = false
        } else {
          this.isShowAddButton = true
        }
        this.isShow = true
        this.init = true
        this.search_key = ""
        this.order_by = {}
        this.attrFilter = {}
        this.attrSortable = {}
        this.cancel()
        this.getChannels()
        await this.getContentList()
      }
    },
  },
  async mounted() {
    if (localStorage.pageSize === undefined) {
      this.pageSize = 10
    } else {
      this.pageSize = Number(localStorage.pageSize)
    }
    await this.openInit()
  },
}
</script>

<style scoped>
.content-top {
  margin-top: 10px;
  margin-bottom: 10px;
}
.title {
  text-align: center;
}
.content-search {
  min-width: 302px;
}
.content-search .search {
  margin-left: 20px;
}
.content-main {
  padding: 0 20px;
}

.article-button {
  margin-right: 5px;
}
.content {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
>>> .ivu-table-cell {
  padding: 5px !important;
}
>>> .ivu-tooltip-inner {
  border: 1px solid white;
}
.content-table {
  overflow: visible !important;
}
</style>

<style lang="scss">
/* 让modal居中 */
.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
  .ivu-modal {
    top: 0;
  }
}
</style>
